import React, { useState, useEffect, useMemo } from 'react';
import { IngredientItem } from 'components/customComponents/Layers/InputGroups';
import ELayersView from 'enums/ELayersView';
import 'components/customComponents/Layers/SelectIngredients.scss';
import { SeedLayerDTO } from 'business/models/CustomModels';
import { GetSeedList } from 'utils/Global';
import { SeedingDTO } from 'business/models/Models';
import { withTabBackButton, WithTabBackButtonStateProps } from 'components/tab';
import { useRMSelector } from 'redux/hooks';
import { selectExp } from 'redux/selectors/ExperimentStateSelector';
import { useLayersContainerContext } from '../Layers/hooks';
import { getTreeNodeIdsByType } from '../Layers/utils';
import ETreeNodeTypes from 'enums/ETreeNodeTypes';
import { LoadingDiv } from 'components/generic';

interface SelectSeedListProps extends WithTabBackButtonStateProps {
  setContentView: (contentView: ELayersView) => void;
  setSelectedSeed: (selectedSeed: SeedingDTO) => void;
  setEditSeedData: (...args) => void;
  editSeedData: any;
  setSelectedSeedName: (seedName: string) => void;
  handleBackToPreviousScreen: (contentView: ELayersView) => () => void;
}
function SelectSeedList(props: SelectSeedListProps) {
  const {
    setContentView,
    setEditSeedData,
    setSelectedSeedName,
    setHandleOnTabBackPress,
    handleBackToPreviousScreen,
  } = props;
  const [searchSeed, setSearchSeed] = useState('');
  const globalSeeds = GetSeedList();
  const exp = useRMSelector(selectExp);
  const { treeControlState } = useLayersContainerContext();
  const treeNodeSeedIds = getTreeNodeIdsByType(
    treeControlState.treenodes,
    ETreeNodeTypes.Seed,
  );
  const seedList = useMemo(() => {
    if (!treeNodeSeedIds?.size) {
      return [];
    }
    return globalSeeds
      .filter((seed) => treeNodeSeedIds.has(seed.treeNodeId))
      .filter((seed) => seed.name?.toLowerCase().includes(searchSeed.toLowerCase()));
  }, [globalSeeds, treeNodeSeedIds, searchSeed]);

  useEffect(() => {
    setHandleOnTabBackPress(() =>
      handleBackToPreviousScreen(ELayersView.LAYERDESIGNVIEW),
    );
  }, [setHandleOnTabBackPress]);

  function selectSeed(seed) {
    const seedLayerDTO: SeedLayerDTO = new SeedLayerDTO();
    seedLayerDTO.layerName = seed.name;
    seedLayerDTO.layerId = -1;
    seedLayerDTO.seedDropVolumeVaryAlong = 1;
    seedLayerDTO.startSeedDropVolume = exp.containerDefSeedVolume;
    seedLayerDTO.stopSeedDropVolume = exp.containerDefSeedVolume;
    seedLayerDTO.seedId = seed.id;

    setSelectedSeedName(seed.name);
    setEditSeedData(seedLayerDTO);

    setContentView(ELayersView.EDITSEED);
  }

  function changeSearchIngredient(e) {
    setSearchSeed(e.target.value);
  }

  if (treeControlState?.isLoading) {
    return (
      <div className="m-4">
        <LoadingDiv />
      </div>
    );
  }

  return (
    <div
      id="commandpanel-seedinglayer-selectseedlist-wrapper"
      className="select-ingredients-tabs"
    >
      <div
        id="commandpanel-seedinglayer-selectseedlist-searchbar-wrapper"
        className="flex flex-space-between"
        style={{ padding: '1.45% 4.36%' }}
      >
        <input
          id="commandpanel-seedinglayer-selectseedlist-searchinput"
          type="text"
          placeholder="Search Seeds"
          style={{ width: '100%', padding: '1.25% 2.34%', height: '30px' }}
          value={searchSeed}
          onChange={changeSearchIngredient}
        />
      </div>
      <div
        id="commandpanel-seedinglayer-selectseedlist-container"
        className="ingredients-container"
      >
        {seedList.map((seed) =>
          searchSeed === '' ||
          String(seed.name).toLocaleLowerCase().indexOf(searchSeed.toLowerCase()) > -1 ? (
            <IngredientItem
              text={seed.name}
              key={seed.id}
              onClick={() => selectSeed(seed)}
            />
          ) : null,
        )}
      </div>
    </div>
  );
}

export default withTabBackButton(SelectSeedList);
